import React, {Component} from 'react';
import './App.css';
import NavigationBar from "./components/NavigationBar";
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import MachineList from "./components/machineFragment/MachineList";
import MachineAdd from "./components/machineFragment/MachineAdd";
import Home from "./components/Home";
import ErrorPage from "./components/ErrorPage";
import AppProvider, {AppContext} from "./AppContext";
import CustomerList from "./components/customerFragment/CustomerList";
import '../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css'
import CategoryList from "./components/categoryFragment/CategoryList";
import UserList from "./components/userFragment/UserList";
import CategoryAdd from "./components/categoryFragment/CategoryAdd";
import CategoryEdit from "./components/categoryFragment/CategoryEdit";
import CustomerEdit from "./components/customerFragment/CustomerEdit";
import CustomerAdd from "./components/customerFragment/CustomerAdd";
import MachineEdit from "./components/machineFragment/MachineEdit";
import UserAdd from "./components/userFragment/UserAdd";
import UserEdit from "./components/userFragment/UserEdit";
import Logs from "./components/logFragment/Logs";
import Login from "./components/Login";
import Footer from "./components/Footer";
import MyAccount from "./components/settings/Settings";
import MachineInspectionsList from "./components/machineInspectionList/MachineInspectionsList";
import ServicesList from "./components/servicesFragment/ServicesList";
import Tutorials from "./components/tutorials/Tutorials";
import MachineTodo from "./components/machineTodo/MachineTodo";
import Statistics from "./components/statistics/Statistics";
import Map from "./components/map/Map";
import Privacy from "./Privacy";
import MachineExternalAdd from "./components/machineFragment/external/MachineExternalAdd";
import MachineExternalEdit from "./components/machineFragment/external/MachineExternalEdit";
import MachineExternalList from "./components/machineFragment/external/MachineExternalList";
import ServicesExternalList from "./components/machineFragment/external/ServicesExternalList";


class App extends Component {

    static contextType = AppContext;

    render() {

        return (
            <AppProvider>
                <Router>
                    <NavigationBar></NavigationBar>

                    <div>

                        <Routes>
                            <Route path="/" element={<Login/>}/>
                            <Route path="/home" element={<Home/>}/>
                            <Route path="/machineAdd" element={<MachineAdd/>}/>
                            <Route path="/machineEdit" element={<MachineEdit/>}/>
                            <Route path="/machineList" element={<MachineList/>}/>
                            <Route path="/customerAdd" element={<CustomerAdd/>}/>
                            <Route path="/customerEdit" element={<CustomerEdit/>}/>
                            <Route path="/customerList" element={<CustomerList/>}/>
                            <Route path="/categoryAdd" element={<CategoryAdd/>}/>
                            <Route path="/categoryEdit" element={<CategoryEdit/>}/>
                            <Route path="/categoryList" element={<CategoryList/>}/>
                            <Route path="/userList" element={<UserList/>}/>
                            <Route path="/userAdd" element={<UserAdd/>}/>
                            <Route path="/userEdit" element={<UserEdit/>}/>
                            <Route path="/logs" element={<Logs/>}/>
                            <Route path="/login" element={<Login/>}/>
                            <Route path="/myAccount" element={<MyAccount/>}/>
                            <Route path="/machinePeriodicInspection" element={<MachineInspectionsList/>}/>
                            <Route path="/servicesList" element={<ServicesList/>}/>
                            <Route path="/tutorials" element={<Tutorials/>}/>
                            <Route path="/machineTodo" element={<MachineTodo/>}/>
                            <Route path="/statistics" element={<Statistics/>}/>
                            <Route path="/map" element={<Map/>}/>
                            <Route path="/privacy" element={<Privacy/>}/>

                            <Route path="/machineExternalAdd" element={<MachineExternalAdd/>}/>
                            <Route path="/machineExternalEdit" element={<MachineExternalEdit/>}/>
                            <Route path="/machineExternalList" element={<MachineExternalList/>}/>
                            <Route path="/servicesExternalList" element={<ServicesExternalList/>}/>

                            <Route path="*" element={<ErrorPage/>}/>
                        </Routes>
                    </div>
                    <Footer/>
                </Router>
            </AppProvider>
        );
    }
}

export default App;
